module.exports = __webpack_public_path__ + "3dc5884689228328018f2d58ba609207.png";


//////////////////
// WEBPACK FOOTER
// ./public/src/images/github-logo.png
// module id = 976
// module chunks = 0